<template>
  <div id="app">
    <LanguageSwitch class="app-language-switch" />
    <router-view></router-view>
  </div>
</template>

<script>
import LanguageSwitch from '@/components/LanguageSwitch.vue'

export default {
  name: 'App',
  components: {
    LanguageSwitch,
  },
}
</script>

<style>
html {
  overflow-y: scroll;
  scrollbar-gutter: stable;
}

body {
  margin: 0;
}

#app {
  min-height: 100vh;
}

.app-language-switch {
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000;
}

@media (max-width: 768px) {
  .app-language-switch {
    top: 12px;
  }
}
</style>
